import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export function moveTabs(props) {
    const { step, direction, tabs, wrapper, tabsAnimation, onComplete } = props;
    const tabsRect = tabs.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    let scrollPosition = Math.abs(tabsRect.x - wrapperRect.x);
    if (direction === "left" && tabsRect.left < wrapperRect.left) {
        scrollPosition -= Math.min(Math.abs(wrapperRect.left - tabsRect.left), step);
    }
    if (direction === "right" && tabsRect.right > wrapperRect.right) {
        scrollPosition += Math.min(Math.abs(wrapperRect.right - tabsRect.right), step);
    }
    gsap.to(wrapper, Object.assign(Object.assign({}, tabsAnimation), { scrollTo: {
            x: scrollPosition,
        }, onComplete }));
}
//# sourceMappingURL=moveTabs.js.map